import React from 'react';
import DOMPurify from 'utils/sanitize';
import { ReactSVG } from 'react-svg';
import plus_icon from '../img/plus_icon.svg';
import minus_icon from '../img/minus_icon.svg';

export default function template() {
  const { item } = this.props;

  return (
      <div className={`accordion__item item-accordion ${this.state.isOpen ? "open" : ""}`}>
        <div className="item-accordion__label" onClick={this.toggleIsOpen} onKeyDown={(e) => e.key === 'Enter' && this.toggleIsOpen} tabIndex="0" id={item.id}>
          <h3 dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(item.label))}}/>
          {this.state.isOpen ?
            <ReactSVG src={minus_icon} className="item-accordion__icon"/>
          :
            <ReactSVG src={plus_icon} className="item-accordion__icon"/>
          }
        </div>
        {this.state.isOpen && <div className="item-accordion__value value-item-accordion" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.value))}}/>}
      </div>
  );
}
